import React from 'react';

export const CardIcon = (props: React.HTMLAttributes<SVGElement>) => (
  <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2.5" y="2.5" width="11" height="11" rx="1.5" stroke="currentColor" />
    <rect x="2" y="7.5" width="12" height="1" fill="currentColor" />
  </svg>
);
